<template>
  <Block :title="t('title')" emoji="🏁">
    <template #actions>
      <router-link to="/admin/analytics/retail/regions" class="text-xs text-primary-dark hover:underline">
        {{ t("view_more") }}
      </router-link>
    </template>
    <template #subtitle>
      <p v-if="currentRegion" class="text-sm text-gray-600">
        <span class="font-bold">#{{ currentRegion.rank }}</span>
        {{ t("position_connector") }}
        <span class="font-bold">{{ totalRegions || regionRanking.length }}</span>
        {{ t("regions_label") }}
      </p>
    </template>

    <BlockList :items="displayedRegions" key-field="name" :row-class="regionRowClass">
      <template #default="{ item: region }">
        <span>
          {{ region.rank }}. {{ region.name }}
          <span v-if="region.current" class="text-gray-500">({{ t("your_region") }})</span>
        </span>
        <span class="font-bold whitespace-nowrap">{{ region.salesCount }}</span>
      </template>
    </BlockList>
  </Block>
</template>

<script>
import { Block, BlockList, computeCompetitionRanking } from "@estaly/ui";
import { useI18n } from "vue-i18n";

const TOP_COUNT = 5;

export default {
  components: {
    Block,
    BlockList,
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  props: {
    regionRanking: {
      type: Array,
      required: true,
    },
    totalRegions: {
      type: Number,
      default: null,
    },
  },
  computed: {
    rankedRegions() {
      return computeCompetitionRanking(this.regionRanking, "salesCount").map((region) => ({
        rank: region.rank,
        name: region.name,
        salesCount: region.salesCount,
        current: region.current || false,
      }));
    },
    currentRegion() {
      return this.rankedRegions.find((r) => r.current);
    },
    regionRowClass() {
      return (region) => (region.current ? "bg-green-50" : "");
    },
    displayedRegions() {
      const top = this.rankedRegions.slice(0, TOP_COUNT);
      const currentInTop = top.some((r) => r.current);

      if (currentInTop || !this.currentRegion) {
        return top;
      }

      return [...this.rankedRegions.slice(0, TOP_COUNT - 1), this.currentRegion];
    },
  },
};
</script>

<i18n src="./RegionRankingBlock.i18n.json"></i18n>
